import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import api, { setApiGlobalErrorHandler } from '../services/api';
import { useAuth } from '../AuthContext';
import { useToasts } from '../components/ToastContext';

export default function MainLayout() {
  const navigate = useNavigate();
  const { user, logout, isLoggedIn } = useAuth();
  const [profile, setProfile] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const { showToast } = useToasts();

  // Register global API error handler (for all toasts)
  useEffect(() => {
    setApiGlobalErrorHandler((msg, type = 'error') => showToast(msg, type));
  }, [showToast]);

  // Fetch profile & notifications independently
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const profileRes = await api.get('/users/me');
        setProfile(profileRes.data);
      } catch (err) {
        showToast('Failed to load profile.', 'error');
      }
      try {
        const notifRes = await api.get('/notifications');
        setNotifications(notifRes.data || []);
      } catch (err) {
        // Optional: showToast('Failed to load notifications.', 'warning');
        setNotifications([]);
      }
      setLoading(false);
    }
    if (isLoggedIn) fetchData();
    else setLoading(false);
  }, [isLoggedIn, showToast]);

  // Robust logout handler (calls AuthContext, optional API)
  const handleLogout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (err) {
      // Fallback: logout anyway
    }
    logout(); // AuthContext logout clears tokens/session
    showToast('You have been logged out.', 'success');
    navigate('/login');
  };

  if (loading) return <div className="main-loading">Loading...</div>;

  return (
    <>
      <Navbar
        userRole={profile?.role || user?.role}
        profile={profile}
        notifications={notifications}
        onLogout={handleLogout}
      />
      <div className="main-content">
        <Outlet
          context={{
            profile,
            notifications,
            showToast,
          }}
        />
        <Footer /> {/* Add the Footer component here */}
      </div>
      {/* Toasts are handled globally by ToastProvider */}
    </>
  );
}
